<nz-spin [nzSpinning]="loading()">
  <form nz-form [formGroup]="form" nzLayout="vertical" (ngSubmit)="submit()">
    <!-- Package Info -->
    <div class="p-3 bg-gray-50 rounded mb-4">
      <div class="font-medium">{{ packageName }}</div>
      <div class="text-sm text-gray-500">
        {{ 'servicePackages.form.price' | translate }}: {{ packagePrice | number:'1.2-2' }} ₾
      </div>
    </div>

    <!-- Customer Search + add / view (same behaviour as visit create) -->
    <div class="flex items-start gap-2">
      <div class="min-w-0 flex-1">
        <beautyapp-select-search
          formControlName="userId"
          [label]="'servicePackages.sellModal.customer' | translate"
          [placeholder]="'servicePackages.sellModal.searchCustomer' | translate"
          [data]="customers()"
          displayMember="name"
          valueMember="id"
          (onSearch)="onCustomerSearch($event)"
        ></beautyapp-select-search>
      </div>
      <div class="flex items-center gap-2" style="margin-top: 25px">
        <button
          type="button"
          nz-button
          nzType="primary"
          nzShape="circle"
          [title]="'calendar.createUser' | translate"
          (click)="addNewUser()"
        >
          <i nz-icon nzType="user-add" nzTheme="outline"></i>
        </button>
        @if (form.controls.userId.value) {
          <button
            type="button"
            nz-button
            nzType="default"
            nzShape="circle"
            (click)="viewUser()"
          >
            <i nz-icon nzType="eye" nzTheme="outline"></i>
          </button>
        }
      </div>
    </div>

    <!-- Gift: buy for another customer (beaut-251) -->
    <div class="flex flex-col gap-2 mt-2">
      <label
        nz-checkbox
        [ngModel]="isGift()"
        (ngModelChange)="toggleGift($event)"
        [ngModelOptions]="{ standalone: true }"
      >
        {{ 'services.packages.buyForAnother' | translate }}
      </label>
      @if (isGift()) {
      <div class="flex items-start gap-2">
        <beautyapp-select-search
          class="min-w-0 flex-1"
          formControlName="beneficiaryUserId"
          [placeholder]="'services.packages.selectBeneficiary' | translate"
          [data]="beneficiaries()"
          displayMember="name"
          valueMember="id"
          (onSearch)="onBeneficiarySearch($event)"
        ></beautyapp-select-search>
        <button
          type="button"
          nz-button
          nzType="primary"
          nzShape="circle"
          [title]="'calendar.createUser' | translate"
          (click)="addNewBeneficiary()"
        >
          <i nz-icon nzType="user-add" nzTheme="outline"></i>
        </button>
      </div>
      }
    </div>

    <!-- Customer balance preview. Shown only when a customer is selected; red
         when below packagePrice so the cashier sees at a glance whether
         BALANCE payment is viable. -->
    @if (selectedBalance() !== null) {
      <div class="text-xs text-gray-500 mt-1 mb-2 px-1">
        {{ 'PAYMENTTYPE.5' | translate }}:
        <span
          class="font-medium"
          [class.text-red-500]="selectedBalance()! < packagePrice"
          [class.text-green-600]="selectedBalance()! >= packagePrice"
        >
          {{ selectedBalance() | number: '1.2-2' }} ₾
        </span>
      </div>
    }

    <nz-divider></nz-divider>

    <!-- Payment method selector + per-method channel inputs -->
    <beautyapp-payment-method-block
      [group]="form"
      [amount]="packagePrice"
    ></beautyapp-payment-method-block>

    <!-- Payment total must equal the package price -->
    @if (form.errors?.['paymentSumMismatch']; as e) {
      <div class="mt-1 px-1 text-xs text-red-500">
        {{ 'servicePackages.sellModal.paymentSumMismatch' | translate }}:
        {{ e.entered | number: '1.2-2' }} / {{ e.expected | number: '1.2-2' }} ₾
      </div>
    }

    <!-- Comment -->
    <beautyapp-input
      formControlName="comment"
      [label]="'servicePackages.sellModal.comment' | translate"
      [placeholder]="'servicePackages.sellModal.commentPlaceholder' | translate"
    ></beautyapp-input>

    <!-- Actions -->
    <div class="flex justify-end gap-2 mt-4">
      <button nz-button type="button" (click)="cancel()">
        {{ 'buttons.close' | translate }}
      </button>
      <button
        nz-button
        nzType="primary"
        type="submit"
        [nzLoading]="loading()"
        [disabled]="form.invalid"
      >
        {{ 'servicePackages.buttons.sell' | translate }}
      </button>
    </div>
  </form>
</nz-spin>
